const Cart = (function(window, $) {

    const euroSign = '\u20AC';

    var config = {};

    function Cart() {
      config = window.shopSettings;

      // Disable cart functionality completely
      if (config.ajaxCart === false) {
        return;
      }

      this.$body = $("body");
      this.$overlay = $(".overlay-default");
      this.$tabContent = $(".footer .tab-content");

      this.$cartIcon = $(".icon-shopping-cart-holder");
      this.$footer = $(".footer");
      this.$amountFrom = $(".delivery .from");
      this.$cartCounter = $('<span class="cart-badge" />').insertBefore(
        this.$cartIcon
      );
      this.$cartModal = $(".cart-modal-container");
      this.$cartModalMain = $(".cart-modal-main");
      this.$mainShoppingCart = $(".main-shopping-cart");

      // Amount of visually visible products in cart modal
      this.visibleProducts = 1;

      // Default cart content
      this.cart = {
        lines: [],
        amountTotal: 0,
        deliveryCost: 0,
      };

      // List products in cart by EAN number to prevent double additions
      this.references = [];

      this.makeIconClickable();
      // this.getCartContent();
      // this.update();

      // this.addEvents();
    }

    /**
     * Update interface and button states
     */
    Cart.prototype.update = function() {
        // Get actual products in cart
        let references = this.cart.lines.map(item => {
            return item.reference.toString();
        });

        this.references = references;

        this.modifyOrderButtonsState(references);
        this.$cartModalMain.html(this.renderCartModalHtml(this.cart));
        this.$cartCounter.html(this.renderCartCounterHtml(this.cart));
    };

    /**
     * Make cart icon clickable
     */
    Cart.prototype.makeIconClickable = function() {
        this.$cartIcon.replaceWith(function() {
            return '<a href="' + config.cartPage + '" class="' + $(this).attr('class') + '" title="Ga naar je winkelwagen"></a>';
        });
        this.$cartCounter.wrap('<a href="' + config.cartPage + '" title="Ga naar je winkelwagen"></a>');
    };

    /**
     * Add event handlers
     */
    Cart.prototype.addEvents = function() {
        this.$body.on('click', '[data-add-to-cart]', this.addToCartButtonClick.bind(this));
        this.$body.on('click', '.cart-modal-close', this.closeClick.bind(this));
        this.$overlay.on('click', this.closeClick.bind(this));
    };

    /**
     * Get cart contents through API
     * @return {jQuery.promise}
     */
    Cart.prototype.getCartContent = function() {
        if (!config.api) {
          return;
        }
        return $.ajax({
            url: config.api,
            type: 'GET',
            xhrFields: {
                withCredentials: true // Needed to send cookies with API request
            }
        }).done(function(data) {
            this.cart = data;
            this.update();
        }.bind(this));
    };


    /**
     * Change button to 'already added to cart' state
     * @param {Array} references
     */
    Cart.prototype.modifyOrderButtonsState = function(references) {
        // Loop through all add-to-cart buttons on page and change state when present in cart
        this.$body.find('a[data-add-to-cart]').not('[data-within-cart]').each(function(i, elm) {
            let value = $(this).data('add-to-cart').toString();

            // Only modify buttons which are present in cart
            if (references.indexOf(value) === -1) {
                return true; // Skip this iteration
            }

            // Prevent double addition with this flag
            $(this).attr('data-within-cart', 'true');

            // Create 'already in cart' button and hide original
            $('<a/>', {
                'href': this.href,
                'append': checkNestedProperties.exist(themeSettings, 'cart', 'btn_already_in_cart_text') ? '<span class="btn-text ' + themeSettings.cart.btn_already_in_cart_btn_classes + '">' + themeSettings.cart.btn_already_in_cart_text + '</span>' : '',
                'class': checkNestedProperties.exist(themeSettings, 'cart', 'btn_already_in_cart') ? 'btn ' + themeSettings.cart.btn_already_in_cart : 'btn ',
                'data-add-to-cart': value,// Needed because of attached click handlers
                'data-within-cart': 'true'
            }).insertAfter(this).prev().hide();

        });
    };

    /**
     * Price formatter
     * @param {mixed} value
     */
    Cart.prototype.formatPrice = function(value) {
        return value.toFixed(2).toString().replace(".", ","); // Euro sign is unwanted
    };

    /**
     * Generate dynamic cart badge (counter) HTML
     * @param {Object} cart
     * @return string
     */
    Cart.prototype.renderCartCounterHtml = function(cart) {
        if (cart.lines.length === 0) {
            return '';
        }

        return '<span class="no-of-products"><span class="total">' + cart.lines.length + '</span></span>';
    };

    /**
     * Generate dynamic cart modal HTML
     * @param {Object} data
     * @return string
     */
    Cart.prototype.renderCartModalHtml = function(data) {
        var html = '';
        var items = [];

        // start build this modal
        if(themeSettings.new_add_to_cart_modal) {
            // Create product rows
            jQuery.each(data.lines, function(index, item) {
                items.push( '<article class="cart-card-book">'+
                    '<div class="card-book-cover">'+
                    '<img src="'+item.cover+'" alt="'+item.title+'">'+
                    '</div>'+
                    '<div class="card-book-details">'+
                    '<h4 class="book-title">'+item.title+'</h4>'+
                    '<span class="book-author">'+item.author+'</span><br>'+
                    '<span class="book-type">'+item.variant+'</span>'+
                    '</div>'+
                    '</article>');

                // Stop iterating (break loop) when visible amount is reached
                if (index === this.visibleProducts - 1) {
                    return false;
                }
            }.bind(this));
            // Create modal
            html += '<div class="cart-modal-minified">';

            html += '<div class="cart-modal-inner-container">';

            // Modal header
            html += '<a href="#" class="has-icon icon-close has-js cart-modal-close"></a>';

            // Notification
            if (this.feedback) {
                html +='<div class="cart-modal-feedback">'+
                    '<svg height="14" viewBox="0 0 32 32" width="13" xmlns="http://www.w3.org/2000/svg"><path d="m30.1807806.42518642c.3167244-.45244239.9402572-.56246359 1.3926996-.24573923.4222796.29560941.5462723.85848311.3034192 1.30007154l-.0576799.09262809-20.1211488 28.74315888c-1.2408874 1.7826581-3.69213964 2.2222578-5.47459251.9815133-.27610031-.1921317-.52669616-.4195942-.74612997-.6762411l-.15864407-.1978612-5.11866668-6.824c-.33139848-.4418071-.24189462-1.068614.19991247-1.4000125.41235327-.3093052.98586199-.2519578 1.32993637.1162688l.07007613.0836437 5.1181963 6.8233734c.12677599.1687371.27818118.3152294.44781356.4332726.83781713.5831946 1.97656316.4108645 2.60910003-.373941l.08304157-.1108019z" fill="#4EB77F" fill-rule="evenodd"></path></svg>'+
                    '<p>'+this.feedback+'</p>'+
                    '</div>';
                this.feedback = null; // Clear feedback
            }

            // Product summary
            html += items.join('');

            html += '</div>'; // end cart-modal-inner-container

            // Add Blueconic content recommendation empty div
            html += '<div class="bc-placeholder" data-wpg-bc-test="bc-placeholder-modal-contentrecom"></div>';

            // Modal footer
            if(checkNestedProperties.exist(themeSettings, 'cart', 'btn_cart_modal') == true) {
                var btnCartModalToOrder = '<a class="btn ' + themeSettings.cart.btn_cart_modal + '"' + 'href="' + config.cartPage + '">'
            } else {
                var btnCartModalToOrder = '<a class="btn"' + 'href="' + config.cartPage + '">'
            }

            html += '<div class="btn-wrapper">'+
                    '<a href="#" class="cart-modal-close has-js"><span class="btn-text">Verder winkelen</span></a>'+
                    btnCartModalToOrder +
                    '<span class="btn-text">Naar bestellen</span>'+
                    '</a>';


        } else { // NO themeSettings.new_add_to_cart_modal
            // Create product rows
            jQuery.each(data.lines, function(index, item) {
                items.push( '<article class="cart-card-book">'+
                    '<div class="card-book-cover">'+
                    '<img src="'+item.cover+'" alt="'+item.title+'">'+
                    '</div>'+
                    '<div class="card-book-details">'+
                    '<h4 class="book-title">'+item.title+'</h4>'+
                    '<span class="book-author">'+item.author+'</span><br>'+
                    '<span class="book-type">'+item.variant+'</span>'+
                    '<div class="book-totals">'+
                    '<span class="book-total-price">'+this.formatPrice(item.price)+'</span>'+
                    '</div>'+
                    '</div>'+
                    '</article>');

                // Stop iterating (break loop) when visible amount is reached
                if (index === this.visibleProducts - 1) {
                    return false;
                }
            }.bind(this));


            // Create modal
            html += '<div class="cart-modal">';

            // Modal header
            html += '<a href="#" class="has-icon icon-close has-js cart-modal-close"></a>';
            html += '<h4 class="section-title cart-modal-title">Winkelwagen ('+data.lines.length+')</h4>';

            // Notification
            if (this.feedback) {
                html +='<div class="cart-modal-feedback">'+
                    '<svg height="14" viewBox="0 0 32 32" width="13" xmlns="http://www.w3.org/2000/svg"><path d="m30.1807806.42518642c.3167244-.45244239.9402572-.56246359 1.3926996-.24573923.4222796.29560941.5462723.85848311.3034192 1.30007154l-.0576799.09262809-20.1211488 28.74315888c-1.2408874 1.7826581-3.69213964 2.2222578-5.47459251.9815133-.27610031-.1921317-.52669616-.4195942-.74612997-.6762411l-.15864407-.1978612-5.11866668-6.824c-.33139848-.4418071-.24189462-1.068614.19991247-1.4000125.41235327-.3093052.98586199-.2519578 1.32993637.1162688l.07007613.0836437 5.1181963 6.8233734c.12677599.1687371.27818118.3152294.44781356.4332726.83781713.5831946 1.97656316.4108645 2.60910003-.373941l.08304157-.1108019z" fill="#4EB77F" fill-rule="evenodd"></path></svg>'+
                    '<p>'+this.feedback+'</p>'+
                    '</div>';
                this.feedback = null; // Clear feedback
            }

            html += '<div class="product-summary-container default-state">';

            if (items.length === 0) {
                html += '<p>Er staan geen artikelen in het winkelmandje.</p>';
            } else {
                html += items.join('');
            }

            // Show amount of products 'hidden' in cart modal
            if (data.lines.length > 1) {
                var hiddenProducts = data.lines.length - this.visibleProducts;
                let label = hiddenProducts === 1 ? '1 artikel' : hiddenProducts + ' artikelen';
                html += '<a class="additional-no-of-items" href="' + config.cartPage + '" title="Ga naar je winkelwagen">+ '+ label +'</a>';
            }

            html += '</div>';


            // Modal footer
            if(checkNestedProperties.exist(themeSettings, 'cart', 'btn_cart_modal') == true) {
                var btnCartModalToOrder = '<a class="btn ' + themeSettings.cart.btn_cart_modal + '"' + 'href="' + config.cartPage + '">'
            } else {
                var btnCartModalToOrder = '<a class="btn"' + 'href="' + config.cartPage + '">'
            }

            html += '<div class="section-order-totals">'+
                '<div class="order-totals-item sub">'+
                '<span class="label-subtotal">Subtotaal</span>'+
                '<span class="from-for-container">'+
                '<span class="amount">'+this.formatPrice(data.amountTotal - data.deliveryCost)+'</span>'+
                '</span>'+
                '</div>'+

                '<div class="order-totals-item delivery sub">'+
                '<span class="label-subtotal">Verzendkosten</span>'+

                '<span class="from-for-container">';

            if (this.freeShipping) {
                html += '<span class="amount for free-shipping">GRATIS</span>';
            }
            if (!this.freeShipping) {
                html += '<span class="amount for paid-shipping">'+this.formatPrice(data.deliveryCost)+'</span>';
            }

            html += '</br/></span>'+
                '</div>'+

                '<div class="order-totals-item total">'+
                '<span class="label-subtotal">Totaal</span>'+
                '<span class="from-for-container">'+
                '<span class="amount for">'+this.formatPrice(data.amountTotal)+'</span><br>'+
                '</span>'+
                '</div>'+
                '</div>'+

                '<ul class="cart-usps usp-list">'+
                '<li class="has-icon icon-check-1"><span>Boven 20 euro geen verzendkosten</span></li>'+
                '</ul>'+

                '<div class="btn-wrapper">'+
                btnCartModalToOrder +
                '<span class="btn-text">Naar bestellen</span>'+
                '</a>'+

                '<a href="#" class="cart-modal-close has-js"><span class="btn-text">Verder winkelen</span></a>'+
                '</div>';
        }

        // Close modal
        html += '</div>';

        return html;
    };

    /**
     * Add product to cart through API
     * @param {string} reference
     * @param {Object} productObj An object representing a product.
     * @returns {jQuery.promise}
     */
    Cart.prototype.addProduct = function (reference, productObj) {
        return $.ajax({
            url: config.api,
            data: {
                reference: reference,
                count: 1,
                dataLayer: productObj
            },
            type: 'POST',
            xhrFields: {
                withCredentials: true // Needed to send cookies with API request
            }
        });
    };

    /**
     * Close everything
     * @param {jQuery.event} e
     */
    Cart.prototype.closeClick = function(e) {
        e.preventDefault();

        this.$cartModal.hide().addClass('is-hidden');
        this.$overlay.fadeOut(200).removeClass('has-zindex-101');
        this.$tabContent.removeClass('has-zindex-99');
    };

    /**
     * Click handler for 'add to cart' button
     * @param {jQuery.event} e
     * @returns {jQuery.promise}
     */
    Cart.prototype.addToCartButtonClick = function(e) {
        let $target = $(e.currentTarget);
        let ean = $target.data('add-to-cart').toString(); // Should contain EAN number

        e.preventDefault();

        // Check if product already in cart
        let index = this.references.findIndex(value => {
            return ean === value;
        });

        // Display message when already in cart
        if (index !== -1 && ! $target.data('cart-message')) {
            $target.data('cart-message', 'already-in-cart');
            $('<div class="feedback-notice feedback-notice-info has-icon cart-message">Dit boek zit al in je winkelwagen. Ga naar <a href="' + config.cartPage + '">je winkelwagen</a> om het aantal aan te passen.</div>')
                .appendTo($target.parent().parent()); // Insert after button container
        }

        // Prevent double addition to cart
        if (index !== -1) {
            return;
        }

        let product = Events.createProduct($target, {
            item_id: ean
        });

        // for backwards compatibilty fire also old GA3 event
        // Events.fireEcommerceEventGA3(product);

        // New GA4 event
        Events.fireEcommerceEvent('items', product, 'ecommerce_add_to_cart');

        // Should be added immediately so double additions can't occur (eg. fast pressing 'Buy now' multiple times)
        this.references.push(ean);

        this.addProduct(ean, product)
            .always(function(data, status) {

                // Only show when product is added to cart if not on the cart page
                if(this.$mainShoppingCart.length === 0) {
                    this.$cartModal.stop().fadeIn(400).removeClass('is-hidden');
                    this.$overlay.stop().fadeIn(200).addClass('has-zindex-101'); // normally we would like to have the overlay below the header - in this order flow not
                    this.$tabContent.addClass('has-zindex-99'); // normally we would like to have the buy button above the overlay - in this order flow not
                } else {
                    updateCart();
                }

                this.freeShipping = false;
                if(data.deliveryCost === 0){
                    this.freeShipping = true;
                }

                if (status === 'error') {
                    this.feedback = 'Product toevoegen mislukt.';
                } else {
                    this.feedback = 'Toegevoegd aan je winkelwagen';
                    this.cart = data;
                }

                this.update();

            }.bind(this));
    };

    return Cart;

}(window, jQuery));

export {Cart};
